import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const postCommentReplyAddApi = createAsyncThunk(
    'auth/postCommentReplys/Add',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.publicapiAction(`add_reply`, 1), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const postCommentReplyAddSlice = createSlice({
    name: 'postCommentReplyAdd Add',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(postCommentReplyAddApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(postCommentReplyAddApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(postCommentReplyAddApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const postCommentReplyAddReducer = postCommentReplyAddSlice.reducer